// extracted by mini-css-extract-plugin
export default {"TabsContainer":"TabNav-TabsContainer-wdD6B"};